import localeCurrencyFormats from "../i18n/locale-currency-formats";
import {vueInstance} from "../main";

export const getCurrency = (value) => {    
    return localeCurrencyFormats[vueInstance.$i18n.locale].uah;
};